// const API_BASE_PATH = 'http://subasta.local:6788/'
const API_BASE_PATH = process.env.REACT_APP_DOMAIN_API
console.log('API_BASE_PATH', API_BASE_PATH)
const API_ADMIN_PATH = `${API_BASE_PATH}/v1/`

export const API_PATHS = {
	getUser: `${API_ADMIN_PATH}user/get-userinfo`,
	getSetting: `${API_ADMIN_PATH}default/get-setting`,
	updateSetting: `${API_ADMIN_PATH}user/update-setting`,
	login: `${API_ADMIN_PATH}auth/authorize`,
	shopOTP: `${API_ADMIN_PATH}personal/register-service`,
	buyPackage: `${API_ADMIN_PATH}personal/buy-package`,
	changePass: `${API_ADMIN_PATH}user/change-password`,
	addReward: `${API_ADMIN_PATH}personal/add-reward`,
	getOTP: `${API_ADMIN_PATH}auth/push-otp`,
	getAllGame: `${API_ADMIN_PATH}default/get-all-game`,
	getPageInfo: `${API_ADMIN_PATH}default/get-page-info`,
	getPackage: `${API_ADMIN_PATH}default/list-package`,
	getRank: `${API_ADMIN_PATH}default/get-rank`,
	getRankPoint: `${API_ADMIN_PATH}user/get-rank-point`,
	getGift: `${API_ADMIN_PATH}default/gift`,
	getGiftHist: `${API_ADMIN_PATH}user/gift-history`,
	getFriend: `${API_ADMIN_PATH}default/friend`,
	getListRoomOfGame: `${API_ADMIN_PATH}room/list-room`,
	getLevelRoomOfGame: `${API_ADMIN_PATH}room/room-level`,
	createRoomOfGame: `${API_ADMIN_PATH}room/create-room`,
	createRoomByPlayNowOfGame: `${API_ADMIN_PATH}room/playing-now`,
	getRoomDetailOfGame: `${API_ADMIN_PATH}room/room-detail`,
	checkStartGame: `${API_ADMIN_PATH}room/check-start-game`,
	getListFriendInvitePlayGame: `${API_ADMIN_PATH}default/friend`,
	getUserInfo: `${API_ADMIN_PATH}user/get-userinfo`,
	getListInvitation: `${API_ADMIN_PATH}user/list-invitation`,
	acceptInviteFriend: `${API_ADMIN_PATH}user/accept-invite-friend`,
	editUserInfo: `${API_ADMIN_PATH}account/edit-profile`,
	joinRoomNow: `${API_ADMIN_PATH}room/join-now`,
	cancelPackage: `${API_ADMIN_PATH}personal/deregister-service`,
	getCheckEventWater: `${API_ADMIN_PATH}water/check-status`,
	getDropEventWater: `${API_ADMIN_PATH}water/get-drop`,
	getRankEventWater: `${API_ADMIN_PATH}water/get-rank`,
	getCheckEventBoatRacing: `${API_ADMIN_PATH}boat-racing/check-status`,
	getRankEventBoatRacing: `${API_ADMIN_PATH}boat-racing/get-rank`,
	getStepEventBoatRacing: `${API_ADMIN_PATH}boat-racing/get-step`,
	startSpinEventBoatRacing: `${API_ADMIN_PATH}boat-racing/start-spin`,

	getCheckEventBunpimay: `${API_ADMIN_PATH}bunpimay/check-status`,
	getRankEventBunpimay: `${API_ADMIN_PATH}bunpimay/get-rank`,
	getItemsEventBunpimay: `${API_ADMIN_PATH}bunpimay/get-water-guns`,
	startPairingEventBunpimay: `${API_ADMIN_PATH}bunpimay/pairing`,

	getCheckEventBoatRacing102025: `${API_ADMIN_PATH}boat-racing/102025/check-status`,
	getCheckEventBoatRacing102025Boat: `${API_ADMIN_PATH}boat-racing/102025/get-boat`,
	getCheckEventBoatRacing102025Rank: `${API_ADMIN_PATH}boat-racing/102025/get-rank`,

	userCheckSub: `${API_ADMIN_PATH}user/check-sub`,

	luckyStartGameSpin: `${API_ADMIN_PATH}lucky/start-game-spin`,
	getLuckyGameAward: `${API_ADMIN_PATH}lucky/get-game-award`,
	getLuckyGetHistory: `${API_ADMIN_PATH}lucky/get-history`,
	getLuckyGetDailyMission: `${API_ADMIN_PATH}lucky/get-daily-mission`,
	getLuckyGetReceiveDailyMissionReward: `${API_ADMIN_PATH}lucky/receive-daily-mission-reward`,
}
